import { EncumbranceTypes } from 'modules/partners/constants/encumbranceOptions';

export const checkHasMemberSelector = (encumbranceType: string): boolean =>
  encumbranceType === EncumbranceTypes.CO_OWNERSHIP ||
  encumbranceType === EncumbranceTypes.USUFRUCT;
